import { render } from "./ColumnSpacing.vue?vue&type=template&id=58638521&scoped=true"
import script from "./ColumnSpacing.vue?vue&type=script&lang=ts"
export * from "./ColumnSpacing.vue?vue&type=script&lang=ts"

import "./ColumnSpacing.vue?vue&type=style&index=0&id=58638521&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-58638521"

export default script